import "./instrument";

// React core
import React from "react";
import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

// Tailwind stylesheet
import "./css/tailwind.css";

// ZaUI stylesheet
import "zmp-ui/zaui.css";

// Mantine stylesheet
import '@mantine/core/styles.css';
import '@mantine/carousel/styles.css';
import '@mantine/dates/styles.css';

// Your stylesheet
import "./css/app.css";

dayjs.extend(customParseFormat)
dayjs.extend(utc)
dayjs.extend(timezone)

// Expose app configuration
// import appConfig from "../app-config.json";
// if (!window.APP_CONFIG) {
//   window.APP_CONFIG = appConfig;
// }

// Mount the app
import App from "./components/app";
const root = createRoot(document.getElementById("app")!, {
  onUncaughtError: Sentry.reactErrorHandler(),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
});
root.render(React.createElement(App));
